<template>
  <section v-on:click="sectionClicked" class="textBlock features">
    <div class="theText" v-html="section.text[lang]"
      :style="{'font-size': section.fontSize, 'font-weight': section.fontWeight,
      'font-style': section.fontStyle, color: section.textColor, 'max-width': section.maxWidth,
      'text-decoration': section.textDecoration, 'text-align': section.textAlign,
      'font-family': section.font}"></div>
  </section>
</template>

<script>
export default {
  name: 'home',
  props: ['section'],
  components: {},
  data() {
    return {
      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
.textBlock{
  .theText{
    white-space: pre-line;
    margin: 0 auto;
  }
}
</style>
